/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelStopRecOrder.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/stop-rec-order";

export class AutogenModelStopRecOrder<RowType extends ModelRow> extends Endpoint<RowType, RowStopRecOrderFields> {
    constructor(ctor: RowConstructor) {
        super(endpointPath, ctor);
    }
}

export class AutogenRowStopRecOrder extends ModelRow<RowStopRecOrderFields> {
    constructor(values?: Partial<RowStopRecOrderFields>) {
        super(endpointPath, true, values);
    }
}

export interface RowStopRecOrderFields {
    actual_arrival: Date;
    actual_departure: Date;
    address: string;
    address2: string;
    appointment_status_id: string;
    appt_required: string;
    cases: number;
    city_id: number;
    city_name: string;
    company_id: string;
    confirmed: string;
    contact_name: string;
    dist_from_prev: number;
    dist_from_prev_um: string;
    driver_load_unload: string;
    edi_code: string;
    edi_loc_code: string;
    eta: Date;
    google_place_id: string;
    hub: number;
    id: string;
    latitude: number;
    location_id: string;
    location_name: string;
    longitude: number;
    movement_id: string;
    movement_sequence: number;
    order_id: string;
    order_sequence: number;
    pallets_dropped: number;
    pallets_picked_up: number;
    phone: string;
    ponum: string;
    projected_arrival: Date;
    refno: string;
    sched_arrive_early: Date;
    sched_arrive_late: Date;
    seal: string;
    showas_address: string;
    showas_address2: string;
    showas_city_id: number;
    showas_city_name: string;
    showas_location_id: string;
    showas_location_name: string;
    showas_state: string;
    showas_zip_code: string;
    signed_for_name: string;
    state: string;
    status: string;
    stop_type: string;
    volume: number;
    volume_um: string;
    weight: number;
    weight_um: string;
    zip_code: string;
    zone_id: string;
}

